import type { UseFormProps } from 'react-hook-form';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';

export type FormRequest = {
  productPlanId: string;
  inquiry: string;
  softwareId: string;
  requester?: string;
  files?: File[];
};

export const useItAdminFormOptions = () => {
  const validationItAdminSchema = Yup.object().shape({
    productPlanId: Yup.string().required('Product_Use_Request_10'),
    inquiry: Yup.string(),
    requester: Yup.string().optional().nullable(),
    files: Yup.array().of(Yup.mixed<File>()).optional(),
  });
  const ItAdminFormOptions: UseFormProps<FormRequest> = {
    resolver: yupResolver(validationItAdminSchema),
    mode: 'onChange',
    shouldFocusError: true,
  };
  return useForm<FormRequest>(ItAdminFormOptions);
};
